"use client"

import { signOut } from "next-auth/react"
import Link from "next/link"
import styles from "./auth-buttons.module.css"
import { LogOut } from "lucide-react"

interface AuthButtonsProps {
    user?: {
        name?: string | null
        email?: string | null
    }
    variant?: "dark" | "light"
}

export function AuthButtons({ user, variant = "dark" }: AuthButtonsProps) {
    const variantClass = variant === "light" ? styles.light : styles.dark

    if (user) {
        return (
            <div className={`${styles.container} ${variantClass}`}>
                <div className={styles.userInfo}>
                    <span className={styles.userName}>{user.name}</span>
                    <span className={styles.userEmail}>{user.email}</span>
                </div>
                <button
                    onClick={() => signOut({ callbackUrl: "/" })}
                    className={styles.logoutButton}
                    title="Uitloggen"
                >
                    <LogOut size={20} />
                </button>
            </div>
        )
    }

    return (
        <div className={`${styles.container} ${variantClass}`}>
            <Link href="/login" className={styles.signInButton}>
                Aanmelden
            </Link>
        </div>
    )
}
